<template>
  <div>
    <el-row class="el-container">
        <h4>Quản lý nội dung</h4>
    </el-row>
    <br />
    <el-row>
      <h5 style='display: inline-block'>Danh sách câu thông dụng</h5>
      <span class="text-description">Các câu thông dụng sẽ được đánh dấu loại bỏ trong quá trình kiểm tra tài liệu.</span>
    </el-row>
    <el-row style="margin-top: 10px">
      <el-col :span="2">
        <el-button type="primary" @click="$refs[refs.UPLOAD_BLACKLIST].showModal()">
          <FAIcon icon="fas fa-upload" :color="Colors.WHITE"/>
          Tải lên
        </el-button>
      </el-col>

      <el-col :span="2" :offset="1">
        <el-button style="margin-left: 10px" type="primary" @click="downloadBlacklistFile">
          <FAIcon icon="fas fa-file-download" :color="Colors.WHITE"/>
          Tải xuống
        </el-button>
      </el-col>
    </el-row>
    <UploadBlacklistModel :ref="refs.UPLOAD_BLACKLIST" />
  </div>
</template>

<script>
import FAIcon from '@/components/common/FAIcon.vue'
import { Colors } from '@/constants/DoITConstant.js'
import { pushArraybuffer2Client } from '@/helpers/DownloadHelper'
import UploadBlacklistModel from '@/components/dashboard/content/action-models/UploadBlacklistModel'
import { apiGetBlacklistFileAsArrayBuffer } from '@/services/admin_dashboard_service'

export default {
  name: 'AdminContentManagement',
  components: { UploadBlacklistModel, FAIcon },
  data() {
    return {
      Colors,
      refs: {
        UPLOAD_BLACKLIST: 'UPLOAD_BLACKLIST',
      },
    }
  },
  methods: {
    reloadTable() {
      this.$refs[this.refs.USER_TABLE].loadItems()
    },
    async downloadBlacklistFile() {
      let res = await apiGetBlacklistFileAsArrayBuffer()
      if (res == null) {
        this.$message({
          message: 'Có lỗi xảy ra',
          type: 'error'
        })
      } else {
        pushArraybuffer2Client(res, 'blacklist.txt')
      }
    }
  },
}
</script>

<style scoped>
.text-description {

  margin-left: 50px;
  color: #8d9094;
}
</style>
